import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Typography from '../../Generic/Typography';
import { Button } from '../../Generic/Button';
import cardStyles from './Card-tw-styles';
import getWidth from '../../../utils/gridWidth';
import { VideoButton } from '../../Generic/VideoButton';
import videoButtonStyles from '../../Generic/VideoButton/VideoButton-tw-styles';
import { getButtonVariant } from '../../../utils/uiHelper';
import { getCdnImage } from '../../../utils/ImageManager';
import getCdnSrcset from '../../../utils/srcSetHelper';
import brandButtonStyles from '../Button/Button-tw-styles';
import i18nMessages from '../../../constants/messages/pt-BR';
import DOMPurify from 'isomorphic-dompurify';
import { CardMedia, Card, CardContent, CardActions } from '../../Generic/Card';

class StackedCard extends React.PureComponent {
  constructor(props){
    super(props);
    this.state={showMore:false}
  }
  showMore = () => {
    // eslint-disable-next-line react/destructuring-assignment
    if(this.state.showMore){
        this.setState({showMore:false})
    }else{
        this.setState({showMore:true})
    }
   
}
  render() {
    const {
      cardType,
      data,
      pictureLazyLoad
    } = this.props;
    // eslint-disable-next-line react/destructuring-assignment
    const { showMore } = this.state ;
  const detachBuyNowDialog = this.props;
  const buyNowClickHandler = this.props;
    const defaultCardTypeStyle = 'stackedCard';
    const requestedCardTypeStyle =
      (data.styles && data.styles.trim()) || cardType || defaultCardTypeStyle;
    const cardTypestyle =
      cardStyles[requestedCardTypeStyle] !== undefined
        ? requestedCardTypeStyle
        : defaultCardTypeStyle;
    const resolvedCardStyle = cardStyles[cardTypestyle] || cardStyles[defaultCardTypeStyle];

    const mediaProps = {
      type: i18nMessages.img,
      src:
        data.image && data.image.image
          ? data.image.image.url && data.image.image.url
          : null,
      alt: data.image && data.image.altText,
      tooltip: data.image && data.image.tooltip,
    };
    const widthClass = getWidth(data.componentWidth);

    let cardMedia = '';
    if (mediaProps.src) {
      cardMedia = (
        <CardMedia
          className={classNames(resolvedCardStyle.cardMedia)}
          image={getCdnImage(mediaProps.src, { w: 800 })}
          srcset={getCdnSrcset(mediaProps.src, 800)}
          component={mediaProps.type}
          alt={mediaProps.alt}
          cardType={cardTypestyle}
        />
      );
    } else if (data.image && data.image.__typename === i18nMessages.ImageSet) {
      cardMedia = (
        <CardMedia
          pictureLazyLoad={pictureLazyLoad}
          className={classNames(resolvedCardStyle.cardMedia)}
          image={
            data.image &&
            data.image.smartphoneImage &&
            data.image.smartphoneImage.url
          }
          component="picture"
          sizes={mediaProps && mediaProps.sizes}
          srcset={
            data.image && data.image.desktopImage && data.image.desktopImage.url
          }
          alt={mediaProps.alt}
          cardType={cardType}
        />
      );
    }
    let cardMediaLink = '';
    if (
      data.callToActionsCollection &&
      data.callToActionsCollection.items.length > 0 &&
      data.callToActionsCollection.items[0].tooltip !=='VER MAS' &&
      data.callToActionsCollection.items.some(
        obj => obj && obj.__typename !== i18nMessages.VideoButton
      )
    ) {
      cardMediaLink = (
        <a
          data-pgaction-redirection="0"
          href={
            data.callToActionsCollection &&
            data.callToActionsCollection.items[0].link
          }
          className={classNames([data.gaEventClass])}
          title={mediaProps.tooltip}
        >
          {cardMedia}
        </a>
      );
    } else {
      cardMediaLink = cardMedia;
    }
    return (
      <Card
        key={data.sys.id}
        // className={classNames(widthClass, cardStyles[cardTypestyle].card)}
        className={classNames(widthClass, resolvedCardStyle.card,showMore?"active":"inactive")}
      >
        <div className={classNames(resolvedCardStyle.mediaWrapper)}>
          <div className={classNames(resolvedCardStyle.cardMedia)}>
            {cardMediaLink}
          </div>

          {data.callToActionsCollection &&
          data.callToActionsCollection.items.length > 0 ? (
            data.callToActionsCollection.items.map(item => (
              <Button
                href={item.link}
                key={item.id}
                area-label={item.tooltip}
                title={item.tooltip}
                target={item.target}
                className={classNames(item.gaEventClass)}
                data-action-detail={item.gaEventLabel}
              >
                {' '}
                <CardContent
                  className={classNames(resolvedCardStyle.cardContent)}
                >
                  {data.title && (
                    <Typography
                      className={classNames(resolvedCardStyle.header)}
                      component="h2"
                      dangerouslySetInnerHTML={{
                        __html:DOMPurify.sanitize( data.title),
                      }}
                    />
                  )}
                  {data.text && (
                    <Typography
                      className={classNames(
                        resolvedCardStyle.description
                      )}
                      component="div"
                      dangerouslySetInnerHTML={{
                        __html:DOMPurify.sanitize( data.text),
                      }}
                    />
                  )}
                  {data.subTitle && (
                  <Typography
                    className={classNames(resolvedCardStyle.subTitle)}
                    component="div"
                    dangerouslySetInnerHTML={{
                    __html:DOMPurify.sanitize( data.subTitle),
                  }}
                  />
              )}
                  {data.supportingText && showMore && (
                    <Typography
                      className={classNames(resolvedCardStyle.supportingText)}
                      component="div"
                      dangerouslySetInnerHTML={{
                    __html:DOMPurify.sanitize( data.supportingText),
                  }}
                    />
              )}

                </CardContent>
              </Button>
            ))
          ) : (
            <CardContent
              className={classNames(resolvedCardStyle.cardContent)}
            >
              {data.title && (
                <Typography
                  className={classNames(resolvedCardStyle.header)}
                  component="h2"
                  dangerouslySetInnerHTML={{
                    __html:DOMPurify.sanitize( data.title),
                  }}
                />
              )}
              {data.subTitle && (
              <Typography
                className={classNames(resolvedCardStyle.subTitle)}
                component="div"
                dangerouslySetInnerHTML={{
                    __html:DOMPurify.sanitize( data.subTitle),
                  }}
              />
              )}
              {data.text && (
                <Typography
                  className={classNames(resolvedCardStyle.description)}
                  component="div"
                  dangerouslySetInnerHTML={{
                    __html:DOMPurify.sanitize( data.text),
                  }}
                />
              )}
            </CardContent>
          )}

          {data.callToActionsCollection &&
            data.callToActionsCollection.items.length > 0 && (
              <CardActions
                className={classNames(cardStyles[cardTypestyle].cardActions)}
              >
                {data.callToActionsCollection.items.map((action, i) => {
                  if (action && action.tooltip !== 'VER MAS') {
                    switch (action.__typename) {
                      case i18nMessages.VideoButton:
                        if (action.video) {
                          return (
                            <VideoButton
                              key={data.sys.id}
                              index={i}
                              {...action}
                              styleName={videoButtonStyles[action.styles]}
                            />
                          );
                        }
                        return null;
                      case i18nMessages.LinkButton:
                        return (
                          <div
                            key={data.sys.id}
                            className={
                              cardStyles[cardTypestyle].buttonContainer
                            }
                          >
                            {getButtonVariant(
                              {
                                ...action,
                                detachBuyNowDialog,
                                buyNowClickHandler,
                              },
                              classNames(
                                action.styles
                                  ? brandButtonStyles[action.styles.trim()]
                                  : cardStyles[cardTypestyle].button[i],
                                action.gaEventClass
                              )
                            )}
                          </div>
                        );
                      default:
                        return(
                          <a
                            data-pgaction-redirection="0"
                            href={
                              action.link
                          }
                            className={classNames(cardStyles[cardTypestyle].button)}
                            title={mediaProps.tooltip}
                          >
                            {action.linkText}
                          </a>
                        )
                    }
                  }else if( action.tooltip === 'VER MAS'){
                    return <Button className={classNames(cardStyles[cardTypestyle].button)} onClick={this.showMore} key={i}>{showMore ? action.linkText : action.linkText}</Button>
                  }
                })}
              </CardActions>
            )}
        </div>
      </Card>
    );
  }
}

StackedCard.propTypes = {
  cardType: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
  pictureLazyLoad: PropTypes.bool
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const StackedCard = ({prop = val, cardType = 'stackedCard', pictureLazyLoad = true }) =>

export default StackedCard;
